import { Link } from "react-router-dom";
import type { GuaCase } from "@/mocks/cases";

const formatDate = (value: string) => value.replace(/-/g, ".");

const CaseCard = ({ item, rank }: { item: GuaCase; rank?: number }) => (
  <article className="group h-full flex flex-col bg-background-50 border border-background-200/80 rounded-lg overflow-hidden transition-colors hover:border-primary-300">
    <Link to={`/cases/${item.slug}`} className="block relative aspect-[4/3] overflow-hidden">
      <img
        src={item.cover}
        alt={`${item.name} 塌房事件档案封面`}
        title={`${item.name} 塌房事件档案`}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-medium bg-background-50/95 text-foreground-900">
        {item.category}
      </span>
      {typeof rank === "number" && (
        <span className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-sm font-bold">
          {rank}
        </span>
      )}
    </Link>

    <div className="flex flex-col flex-1 p-4 md:p-5">
      <div className="flex items-center gap-3 mb-3">
        <img
          src={item.avatar}
          alt={`${item.name} 头像`}
          className="w-10 h-10 rounded-full object-cover border border-background-200"
        />
        <div className="min-w-0">
          <h3 className="font-heading font-bold text-base text-foreground-950 truncate">
            <Link to={`/cases/${item.slug}`} className="hover:text-primary-600 transition-colors">
              {item.name}
            </Link>
          </h3>
          <p className="text-xs text-foreground-500 truncate">{item.handle}</p>
        </div>
      </div>

      <p className="text-sm text-foreground-700 leading-relaxed line-clamp-3 flex-1">
        {item.summary}
      </p>

      <div className="mt-4 flex flex-wrap gap-2">
        {item.tags.slice(0, 3).map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-900"
          >
            {tag}
          </span>
        ))}
      </div>

      <div className="mt-4 pt-4 border-t border-background-200/80 flex items-center justify-between text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-fire-line text-primary-500" />
          热度 {item.heat}
        </span>
        <span>{formatDate(item.fallDate)} 归档</span>
      </div>
    </div>
  </article>
);

export default CaseCard;